export interface IAdditionValue {
  value?: number | string | null;
  isCurrency?: boolean;
}

export const emptyAdditionValue: IAdditionValue = {
  value: null,
  isCurrency: false,
};

export const isAdditionValue = (obj: unknown): obj is IAdditionValue => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }

  const checkObject = obj as Record<string, unknown>;
  return "value" in checkObject || "isCurrency" in checkObject;
};

export const areAdditionsEqual = (
  a?: IAdditionValue | null,
  b?: IAdditionValue | null,
): boolean =>
  a === b ||
  (!!a && !!b && a.value === b.value && !!a.isCurrency === !!b.isCurrency);
